import { ReactNode } from "react";
import { BackButton } from "../Buttons/BackButton";
import { ThemeStyle } from "../../hooks/useTheme";

type LargePopupModalHeaderProps = {
  title?: string | ReactNode;
  backOnPress: () => void;
  altHeaderLeft?: string;
  headerRight?: ReactNode;
  theme?: ThemeStyle;
};

const LargePopupModalHeader = (props: LargePopupModalHeaderProps) => {
  const { title, backOnPress, altHeaderLeft, headerRight, theme } = props;

  const styles = {
    headerPosition: {
      right: 0,
      left: 0,
      display: "flex",
      justifyContent: "center",
      zIndex: -1,
    },
  };

  return (
    <div className="AlignedRowSpaced">
      <BackButton
        iconName={altHeaderLeft ?? "mdi:close"}
        onPress={backOnPress}
        theme={theme}
      />
      {title ? (
        <div style={{ ...styles.headerPosition, position: "absolute" }}>
          <span className="bodyMedium" style={theme?.PrimaryText}>
            {title}
          </span>
        </div>
      ) : null}
      {headerRight ? <div>{headerRight}</div> : null}
    </div>
  );
};

export default LargePopupModalHeader;
